import _slicedToArray from "E:\\Agents\\Agent-02\\_work\\1\\s\\src\\apps\\dotsite\\node_modules\\babel-preset-react-app\\node_modules\\@babel\\runtime/helpers/esm/slicedToArray";
import './CTAsList.css';
import React from 'react';
import { canUseDOM, get, getColorByTheme, getPageThemeColors } from '../../utils';
import { Text } from '@sitecore-jss/sitecore-jss-react';
import { SitecoreContextReactContext } from '../../utils/SitecoreContextReactContext';
import ComponentsWrapper from '../atoms/ComponentsWrapper';
import RouterLink from '../atoms/RouterLink';
import { convertToAnalyticObject } from '../../utils/analytics';
import { tealiumClickFunc, tealiumMergeClickNewData } from '../../utils/tealium';
var CTAsList = function CTAsList(_ref) {
  var fields = _ref.fields,
    params = _ref.params;
  var sitecoreContext = React.useContext(SitecoreContextReactContext);
  var rtl = Boolean(sitecoreContext && sitecoreContext.rtl);
  var pageEditing = Boolean(sitecoreContext && sitecoreContext.pageEditing);
  var primaryPageThemeColor = get(sitecoreContext, 'themesOfPage.primary');
  var primaryActivePageThemeColor = get(sitecoreContext, 'themesOfPage.primary_active');
  var _React$useState = React.useState(true),
    _React$useState2 = _slicedToArray(_React$useState, 2),
    isVdsite = _React$useState2[0],
    setIsVdsite = _React$useState2[1];
  React.useEffect(function () {
    if (canUseDOM && !document.body.classList.contains('vdsite')) {
      setIsVdsite(false);
    }
  }, []);
  var BackgroundColorHex = get(params, 'BackgroundColorHex');
  var ColorHex = get(params, 'ColorHex');
  var ActiveColorHex = get(params, 'ActiveColorHex');
  var variables = BackgroundColorHex ? {
    '--m36-background-color': BackgroundColorHex,
    '--m36-background-active-color': ActiveColorHex,
    '--m36-color': ColorHex
  } : {
    '--m36-background-color': primaryPageThemeColor ? primaryPageThemeColor : getPageThemeColors(isVdsite).primary,
    '--m36-background-active-color': primaryActivePageThemeColor ? primaryActivePageThemeColor : getPageThemeColors(isVdsite).primary_active,
    '--m36-color': getColorByTheme(primaryPageThemeColor ? primaryPageThemeColor : getPageThemeColors(isVdsite).primary)
  };
  if (!fields) {
    console.warn('CTAsList component render skipped. No fields provided');
    if (pageEditing) {
      return /*#__PURE__*/React.createElement("div", {
        className: "no-data"
      }, " [CTAsList component is empty: please provide data source]");
    }
    return null;
  }
  var threeColumns = params !== undefined && params['Position'] === 'Three Columns' ? true : false;
  var hasTitle = Boolean(get(fields, 'data.item.title.jss.value'));
  var hasItems = Boolean(get(fields, 'data.item.links.length'));
  var hasButton = Boolean(get(fields, 'data.item.ctaLabel.jss.value'));
  var buttonText = hasButton ? get(fields, 'data.item.ctaLabel.jss.value', '') : '';
  var buttonLink = get(fields, 'data.item.cTALink.jss.value');
  var eventsAnalytics = get(fields, 'data.eventsAnalytics') || [];
  if (eventsAnalytics.length) {
    eventsAnalytics = convertToAnalyticObject(eventsAnalytics);
  }
  return /*#__PURE__*/React.createElement(StyledWrapper, {
    rtl: rtl,
    anchorUrlParameter: params['Anchor Url Parameter']
  }, /*#__PURE__*/React.createElement("div", {
    style: variables
  }, hasTitle && /*#__PURE__*/React.createElement(Text, {
    className: "h3 CTAsList-links_heading",
    tag: "h3",
    field: fields.data.item.title.jss
  }), hasItems && /*#__PURE__*/React.createElement("ul", {
    className: "CTAsList-links_list"
  }, fields.data.item.links.map(function (item) {
    return item.ctaLabel && item.cTALink && item.cTALink.jss.value.href && /*#__PURE__*/React.createElement("li", {
      className: "CTAsList-links_li ".concat(threeColumns ? 'CTAsList-links_li_three_columns' : 'CTAsList-links_li_two_columns'),
      key: item.ctaLabel.jss.value
    }, /*#__PURE__*/React.createElement(RouterLink, {
      className: "CTAsList-links_a theme-contrast",
      title: item.ctaLabel.jss.value,
      href: item.cTALink.jss.value.href,
      linktype: item.cTALink.jss.value.linktype,
      onClick: function onClick() {
        return tealiumClickFunc(tealiumMergeClickNewData(eventsAnalytics['titleClickAnalytics'], params), [fields.data.item.title.jss.value, item.ctaLabel.jss.value]);
      }
    }, item.ctaLabel.jss.value, item.iconType.targetItem.icon.jss.value && /*#__PURE__*/React.createElement("div", {
      className: "CTAsList-links_icon",
      dangerouslySetInnerHTML: {
        __html: item.iconType.targetItem.icon.jss.value
      }
    })));
  })), buttonLink && buttonLink.href && buttonText && /*#__PURE__*/React.createElement(RouterLink, {
    className: "btn btn-primary CTAsList-links_btn theme-contrast",
    title: buttonText,
    href: buttonLink.href,
    linktype: buttonLink.linktype,
    onClick: function onClick() {
      return tealiumClickFunc(tealiumMergeClickNewData(eventsAnalytics['seeMoreAnalytics'], params), [fields.data.item.title.jss.value, buttonText]);
    }
  }, buttonText)));
};
var StyledWrapper = function StyledWrapper(_ref2) {
  var children = _ref2.children,
    rtl = _ref2.rtl,
    anchorUrlParameter = _ref2.anchorUrlParameter;
  return /*#__PURE__*/React.createElement(ComponentsWrapper, {
    anchorUrlParameter: anchorUrlParameter,
    className: "".concat(commonStyles, " ").concat(rtl ? rtlStyles : ltrStyles)
  }, children);
};
var commonStyles = "c12pztnm";
var ltrStyles = "ljqlk2";
var rtlStyles = "rjyrggf";
export default CTAsList;